(()=>{
  if(window.__gfCollectionFiltersLoaded) return;
  window.__gfCollectionFiltersLoaded=true;
  const q=(s,root=document)=>root.querySelector(s);
  const qa=(s,root=document)=>Array.from(root.querySelectorAll(s));
  const norm=v=>(v||'').toString().trim().toLocaleLowerCase();
  const collectionPath=url=>{
    try{
      const parsed=new URL(url,location.origin);
      if(parsed.origin!==location.origin) return '';
      const parts=parsed.pathname.split('/').filter(Boolean);
      const index=parts.indexOf('collections');
      return index>=0&&parts[index+1]?'/'+parts.slice(0,index+2).join('/'):'';
    }catch(e){return '';}
  };
  const filterRoot=()=>q('[data-gf-filter-root]');
  const rootPath=()=>collectionPath(filterRoot()?.dataset.gfCurrentCollection||location.pathname)||location.pathname;
  const sectionId=()=>q('#main-collection-filters')?.dataset.id||q('#product-grid')?.dataset.id||'';
  const sortValue=()=>q('.gf-collection-sort__select')?.value||q('#SortBy')?.value||'';
  const shownText=count=>(filterRoot()?.dataset.gfShownTemplate||'__COUNT__ shown').replace('__COUNT__',String(count));
  const noMatchesText=()=>filterRoot()?.dataset.gfNoMatches||'No products match these filters.';

  const isBrandPage=()=>filterRoot()?.dataset.gfBrandCategories==='true';
  const cardCache=new Map();
  let requestId=0;
  let controller=null;
  let suppressOutsideClick=false;

  const scrollController=()=>window[`gfInfiniteScroll:${sectionId()}`];
  function setFeedback(message,error=false){
    const sheet=q('.gf-mobile-filter-sheet');
    if(!sheet) return;
    let feedback=q('[data-gf-filter-feedback]',sheet);
    if(!feedback){
      feedback=document.createElement('div');
      feedback.dataset.gfFilterFeedback='';
      feedback.className='gf-filter-feedback';
      feedback.setAttribute('role','status');
      feedback.setAttribute('aria-live','polite');
      sheet.insertBefore(feedback,q('.gf-mobile-filter-section',sheet));
    }
    feedback.replaceChildren();
    feedback.hidden=!message;
    if(!message) return;
    const text=document.createElement('span');
    text.textContent=message;
    feedback.appendChild(text);
    if(error){
      const retry=document.createElement('button');
      retry.type='button';
      retry.textContent=filterRoot()?.dataset.gfRetry||'Try again';
      retry.addEventListener('click',()=>update());
      feedback.appendChild(retry);
    }
  }

  function setLoading(on){
    const box=q('#ProductGridContainer');
    if(box) box.setAttribute('aria-busy',on?'true':'false');
    const collection=q('#ProductGridContainer .collection');
    if(collection) collection.classList.toggle('loading',on);
  }

  function cleanCard(el){
    [el,...qa('.scroll-trigger,.animate--slide-in,.animate--fade-in',el)].forEach(node=>{
      node.classList.remove('scroll-trigger','animate--slide-in','animate--fade-in');
      node.style.opacity='';
      node.style.transform='';
      node.style.removeProperty('--animation-order');
    });
  }

  function parsePrice(text){
    let s=(text||'').replace(/[^0-9.,-]/g,'');
    if(!s) return 0;
    const comma=s.lastIndexOf(',');
    const dot=s.lastIndexOf('.');
    if(comma>-1&&dot>-1){
      s=comma>dot?s.replaceAll('.','').replace(',','.'):s.replaceAll(',','');
    }else if(comma>-1){
      const tail=s.length-comma-1;
      s=tail===2?s.replace(',','.'):s.replaceAll(',','');
    }else if(dot>-1){
      const tail=s.length-dot-1;
      if(tail!==2) s=s.replaceAll('.','');
    }
    return Number.parseFloat(s)||0;
  }

  function cardData(li){
    cleanCard(li);
    const article=q('[data-gf-product-card]',li);
    const link=q('a[href*="/products/"]',li);
    const id=li.dataset.productId||article?.dataset.productId||'';
    const handle=article?.dataset.productHandle||(()=>{
      try{return link?new URL(link.getAttribute('href'),location.origin).pathname.split('/products/')[1]?.split('/')[0]||'':'';}catch(e){return'';}
    })();
    const vendor=q('.gf-vendor',li)?.textContent?.trim()||'';
    const title=q('.gf-product-card h2',li)?.textContent?.trim()||'';
    const currentPrice=q('.gf-price__current',li)?.textContent||q('.gf-price',li)?.textContent||'';
    const fallbackPreorder=!!q('.gf-stock-badge--preorder',li);
    const fallbackInStock=!!q('.gf-stock-badge:not(.gf-stock-badge--preorder)',li);
    const stockState=article?.dataset.stockState||(fallbackPreorder?'preorder':fallbackInStock?'in-stock':'out-of-stock');
    return {collectionIds:(li.dataset.gfCollections||'').split(',').filter(Boolean),id:id||handle,handle,vendor,vendorKey:norm(vendor),title,price:li.dataset.gfPrice!==undefined?Number(li.dataset.gfPrice):parsePrice(currentPrice),stockState,html:li.outerHTML};
  }

  async function fetchPage(path,page,sort,signal,filterFeed=false){
    const sid=filterFeed?'gf-filter-products':sectionId();
    if(!sid) throw new Error('Missing collection section id');
    const url=new URL(path,location.origin);
    url.search='';
    url.searchParams.set('section_id',sid);
    const preview=new URLSearchParams(location.search).get('preview_theme_id');
    if(preview) url.searchParams.set('preview_theme_id',preview);
    if(sort) url.searchParams.set('sort_by',sort);
    if(page>1) url.searchParams.set('page',String(page));
    const response=await fetch(url,{credentials:'same-origin',signal,headers:{'X-Requested-With':'XMLHttpRequest'}});
    if(!response.ok) throw new Error(`Collection request failed: ${response.status}`);
    const doc=new DOMParser().parseFromString(await response.text(),'text/html');
    if(filterFeed&&!q('[data-gf-filter-products]',doc)) throw new Error('Missing filter results');
    return doc;
  }

  function totalPages(doc){
    const grid=q('[data-gf-filter-products]',doc);
    if(!grid) throw new Error('Missing filter results');
    const pages=Number(grid.dataset.totalPages);
    if(!Number.isInteger(pages)||pages<0) throw new Error('Invalid filter pagination');
    return Math.max(1,pages);
  }

  async function mapLimit(items,limit,worker){
    const out=new Array(items.length);
    let next=0;
    const runners=Array.from({length:Math.min(limit,items.length)},async()=>{
      while(next<items.length){
        const index=next++;
        out[index]=await worker(items[index],index);
      }
    });
    await Promise.all(runners);
    return out;
  }

  async function allCards(path,sort,signal){
    const normalized=collectionPath(path);
    if(!normalized) return [];
    const cacheKey=`${normalized}|${sort||''}`;
    if(cardCache.has(cacheKey)) return cardCache.get(cacheKey);

    const readCards=async doc=>{
      const cards=[];
      const nodes=qa('[data-gf-filter-products] > .grid__item',doc);
      for(let index=0;index<nodes.length;index++){
        if(signal.aborted) throw new DOMException('Aborted','AbortError');
        cards.push(cardData(nodes[index]));
        if(index%25===24) await new Promise(resolve=>setTimeout(resolve,0));
      }
      return cards;
    };
    const first=await fetchPage(normalized,1,sort,signal,true);
    const pages=totalPages(first);
    const groups=[await readCards(first)];
    if(pages>1){
      const rest=await mapLimit(Array.from({length:pages-1},(_,i)=>i+2),6,async page=>{
        const doc=await fetchPage(normalized,page,sort,signal,true);
        return readCards(doc);
      });
      groups.push(...rest);
    }

    const seen=new Set();
    const cards=[];
    groups.forEach(group=>{
      group.forEach(item=>{
        if(item.id&&!seen.has(item.id)){
          seen.add(item.id);
          cards.push(item);
        }
      });
    });
    if(signal.aborted) throw new DOMException('Aborted','AbortError');
    if(cardCache.size>=4) cardCache.delete(cardCache.keys().next().value);
    cardCache.set(cacheKey,cards);
    return cards;
  }

  const activeSubButtons=()=>qa('[data-gf-filter="collection"][data-gf-group="subcategory"].is-active');
  const activeBrandButtons=()=>qa('[data-gf-group="brand"].is-active');
  const activeStockButtons=()=>qa('[data-gf-stock].is-active');

  let categoryLoading=false;
  let categoryReady=false;
  async function loadBrandCategories(){
    if(!isBrandPage()||categoryLoading||categoryReady) return;
    categoryLoading=true;
    const lists=qa('[data-gf-brand-category-list]');
    lists.forEach(list=>{list.textContent='Loading categories…';});
    try{
      const cards=await allCards(rootPath(),rootFetchSort(sortValue()),new AbortController().signal);
      const present=new Set(cards.flatMap(card=>card.collectionIds));
      const template=q('[data-gf-category-candidates]');
      const seen=new Set();
      const candidates=qa('[data-gf-category-id]',template.content).filter(button=>{
        const id=button.dataset.gfCategoryId;
        if(seen.has(id)||!present.has(id)) return false;
        seen.add(id);
        return true;
      });
      lists.forEach(list=>{
        list.replaceChildren(...candidates.map(button=>button.cloneNode(true)));
        if(!candidates.length) list.textContent='No categories available.';
      });
      categoryReady=true;
    }catch(error){
      lists.forEach(list=>{
        list.textContent='Categories could not be loaded. ';
        const retry=document.createElement('button');
        retry.type='button';
        retry.textContent='Try again';
        retry.addEventListener('click',loadBrandCategories);
        list.appendChild(retry);
      });
      console.error('[GEARFULL categories]',error);
    }finally{categoryLoading=false;}
  }
  document.addEventListener('toggle',event=>{
    if(event.target.matches?.('.gf-mobile-linked-filters')&&event.target.open) loadBrandCategories();
  },true);

  function prices(){
    const minInput=qa('[data-gf-price-min]').find(input=>input.value!=='');
    const maxInput=qa('[data-gf-price-max]').find(input=>input.value!=='');
    const min=minInput?Number.parseFloat(minInput.value):null;
    const max=maxInput?Number.parseFloat(maxInput.value):null;
    return {min:Number.isFinite(min)?min:null,max:Number.isFinite(max)?max:null};
  }

  function hasFilters(){
    const p=prices();
    return activeSubButtons().length>0||activeBrandButtons().length>0||activeStockButtons().length>0||p.min!==null||p.max!==null;
  }

  function status(on,count){
    qa('[data-gf-actions]').forEach(el=>el.hidden=!on);
    qa('[data-gf-filter-count]').forEach(el=>el.textContent=shownText(on?count:0));
  }

  function renderFiltered(list){
    const grid=q('#product-grid');
    if(!grid) return;
    q('#ProductGridContainer').dataset.gfFiltered='true';
    grid.dataset.resultCount=String(list.length);
    qa('[data-gf-infinite-scroll]',q('#ProductGridContainer')).forEach(node=>node.remove());
    if(list.length){
      grid.innerHTML=list.map(item=>item.html).join('');
    }else{
      const empty=document.createElement('li');
      empty.className='gf-filter-empty';
      empty.textContent=noMatchesText();
      grid.replaceChildren(empty);
    }
    setFeedback('');
    const pagination=q('.pagination-wrapper');
    if(pagination) pagination.style.display='none';
    status(true,list.length);
    document.dispatchEvent(new CustomEvent('gearfull:collection-updated',{detail:{count:list.length,filtered:true}}));
  }

  function localSort(list,sort){
    const items=[...list];
    if(sort==='price-ascending') return items.sort((a,b)=>a.price-b.price||a.title.localeCompare(b.title));
    if(sort==='price-descending') return items.sort((a,b)=>b.price-a.price||a.title.localeCompare(b.title));
    if(sort==='title-ascending') return items.sort((a,b)=>a.title.localeCompare(b.title));
    if(sort==='title-descending') return items.sort((a,b)=>b.title.localeCompare(a.title));
    return items;
  }

  function rootFetchSort(sort){
    return ['price-ascending','price-descending','title-ascending','title-descending'].includes(sort)?'manual':sort;
  }

  async function renderUnfiltered(sort,signal,id){
    const doc=await fetchPage(rootPath(),1,sort,signal);
    const source=q('#ProductGridContainer',doc);
    const target=q('#ProductGridContainer');
    if(!source||!target) throw new Error('Missing product grid in collection response');
    if(signal.aborted||id!==requestId) return;
    target.innerHTML=source.innerHTML;
    target.dataset.gfFiltered='false';
    scrollController()?.resume();
    setFeedback('');
    status(false,0);
    document.dispatchEvent(new CustomEvent('gearfull:collection-updated',{detail:{filtered:false}}));
  }

  async function update(){
    const id=++requestId;
    if(controller) controller.abort();
    controller=new AbortController();
    const {signal}=controller;
    const sort=sortValue();
    scrollController()?.pause();
    setLoading(true);
    setFeedback(filterRoot()?.dataset.gfLoading||'Loading products…');

    try{
      if(!hasFilters()){
        await renderUnfiltered(sort,signal,id);
        return;
      }

      const subPaths=[...new Set(activeSubButtons().map(btn=>collectionPath(btn.dataset.gfUrl)).filter(Boolean))];
      const brandKeys=new Set(activeBrandButtons().map(btn=>norm(btn.dataset.gfVendor||btn.textContent)).filter(Boolean));
      const stockKeys=new Set(activeStockButtons().map(btn=>btn.dataset.gfStock).filter(Boolean));
      const p=prices();
      const fetchSort=rootFetchSort(sort);

      let pool=[];
      if(subPaths.length&&!isBrandPage()){
        const groups=await Promise.all(subPaths.map(path=>allCards(path,fetchSort,signal)));
        const seen=new Set();
        groups.forEach(group=>{
          group.forEach(item=>{
            if(item.id&&!seen.has(item.id)){
              seen.add(item.id);
              pool.push(item);
            }
          });
        });
      }else{
        pool=await allCards(rootPath(),fetchSort,signal);
      }
      if(id!==requestId) return;

      const categoryIds=new Set(activeSubButtons().map(btn=>btn.dataset.gfCategoryId).filter(Boolean));
      let list=pool.filter(item=>{
        if(isBrandPage()&&categoryIds.size&&!item.collectionIds.some(id=>categoryIds.has(id))) return false;
        if(brandKeys.size&&!brandKeys.has(item.vendorKey)) return false;
        if(stockKeys.size&&!stockKeys.has(item.stockState)) return false;
        if(p.min!==null&&item.price<p.min) return false;
        if(p.max!==null&&item.price>p.max) return false;
        return true;
      });
      list=localSort(list,sort);
      if(id!==requestId) return;
      renderFiltered(list);
    }catch(error){
      if(id===requestId&&error?.name!=='AbortError'){
        setFeedback(filterRoot()?.dataset.gfError||'Products could not be updated. Previous results are still shown.',true);
        console.error('[GEARFULL filters]',error);
      }
    }finally{
      if(id===requestId) setLoading(false);
    }
  }

  function setSub(btn,on){
    const path=collectionPath(btn.dataset.gfUrl);
    qa('[data-gf-filter="collection"][data-gf-group="subcategory"]').forEach(other=>{
      if(collectionPath(other.dataset.gfUrl)===path){
        other.classList.toggle('is-active',on);
        other.setAttribute('aria-pressed',on?'true':'false');
      }
    });
  }

  function setBrand(btn,on){
    const key=norm(btn.dataset.gfVendor||btn.textContent);
    qa('[data-gf-group="brand"]').forEach(other=>{
      if(norm(other.dataset.gfVendor||other.textContent)===key){
        other.classList.toggle('is-active',on);
        other.setAttribute('aria-pressed',on?'true':'false');
      }
    });
  }

  function setStock(btn,on){
    const state=btn.dataset.gfStock;
    qa('[data-gf-stock]').forEach(other=>{
      if(other.dataset.gfStock===state){
        other.classList.toggle('is-active',on);
        other.setAttribute('aria-pressed',on?'true':'false');
      }
    });
  }

  function syncPrice(source){
    const controls=source.closest('[data-gf-price-controls]');
    if(!controls) return;
    const min=controls.querySelector('[data-gf-price-min]')?.value||'';
    const max=controls.querySelector('[data-gf-price-max]')?.value||'';
    qa('[data-gf-price-min]').forEach(input=>input.value=min);
    qa('[data-gf-price-max]').forEach(input=>input.value=max);
  }

  function syncSort(value){
    qa('.gf-collection-sort__select,#SortBy').forEach(select=>{
      if(select.value!==value) select.value=value;
    });
    const url=new URL(location.href);
    url.searchParams.delete('page');
    if(value) url.searchParams.set('sort_by',value); else url.searchParams.delete('sort_by');
    history.replaceState(history.state,'',url.pathname+(url.searchParams.toString()?`?${url.searchParams}`:'')+url.hash);
  }

  function clearAll(){
    qa('[data-gf-filter],[data-gf-stock]').forEach(btn=>{
      btn.classList.remove('is-active');
      btn.setAttribute('aria-pressed','false');
    });
    qa('[data-gf-price-min],[data-gf-price-max]').forEach(input=>input.value='');
    update();
  }

  function closeFilter(details){
    if(!details?.open) return;
    details.open=false;
    const summary=q('.gf-mobile-filter-pill',details);
    if(summary){
      try{summary.focus({preventScroll:true});}catch(e){summary.focus();}
    }
  }

  document.addEventListener('input',event=>{
    const sort=event.target.closest?.('.gf-collection-sort__select,#SortBy');
    if(!sort) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    syncSort(sort.value);
    update();
  },true);

  document.addEventListener('change',event=>{
    const sort=event.target.closest?.('.gf-collection-sort__select,#SortBy');
    if(!sort) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  },true);

  document.addEventListener('keydown',event=>{
    if(event.key!=='Enter'||!event.target.matches?.('[data-gf-price-min],[data-gf-price-max]')) return;
    event.preventDefault();
    syncPrice(event.target);
    update();
  });

  document.addEventListener('submit',event=>{
    if(event.target.closest?.('.gf-collection-sort__form')) event.preventDefault();
  },true);

  document.addEventListener('keydown',event=>{
    if(event.key!=='Escape') return;
    const openFilter=q('.gf-mobile-linked-filters[open]');
    if(openFilter){
      event.preventDefault();
      closeFilter(openFilter);
    }
  });

  document.addEventListener('pointerdown',event=>{
    const openFilter=q('.gf-mobile-linked-filters[open]');
    if(!openFilter) return;
    const sheet=q('.gf-mobile-filter-sheet',openFilter);
    const pill=q('.gf-mobile-filter-pill',openFilter);
    if(sheet?.contains(event.target)||pill?.contains(event.target)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    suppressOutsideClick=true;
    window.setTimeout(()=>{suppressOutsideClick=false;},500);
    closeFilter(openFilter);
  },true);

  document.addEventListener('click',event=>{
    if(!suppressOutsideClick) return;
    suppressOutsideClick=false;
    event.preventDefault();
    event.stopImmediatePropagation();
  },true);

  document.addEventListener('click',event=>{
    const sub=event.target.closest('[data-gf-filter="collection"][data-gf-group="subcategory"]');
    if(sub){
      event.preventDefault();
      setSub(sub,!sub.classList.contains('is-active'));
      update();
      return;
    }

    const brand=event.target.closest('[data-gf-group="brand"]');
    if(brand){
      event.preventDefault();
      setBrand(brand,!brand.classList.contains('is-active'));
      update();
      return;
    }

    const stock=event.target.closest('[data-gf-stock]');
    if(stock){
      event.preventDefault();
      setStock(stock,!stock.classList.contains('is-active'));
      update();
      return;
    }

    const priceApply=event.target.closest('[data-gf-price-apply]');
    if(priceApply){
      event.preventDefault();
      syncPrice(priceApply);
      update();
      return;
    }

    if(event.target.closest('[data-gf-clear-filters]')){
      event.preventDefault();
      clearAll();
    }
  });
})();

;(()=>{
  const portalMobileFilters=scope=>{
    const roots=scope?.querySelectorAll?scope.querySelectorAll('.gf-mobile-linked-filters'):[];
    roots.forEach(filter=>{
      if(filter.parentElement!==document.body){
        document.body.appendChild(filter);
        filter.dataset.gfPortaled='true';
      }
    });
  };
  const initialize=()=>portalMobileFilters(document);
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',initialize,{once:true});
  else initialize();
  document.addEventListener('shopify:section:load',event=>portalMobileFilters(event.target));
})();
